import { useNavigate } from "react-router-dom";
import { Home, Sparkles } from "lucide-react";
import { useRoomRefreshFlag } from "@/hooks/useRoomRefreshFlag";

/**
 * Two-tab bottom navigation shown only when the Room Refresh feature flag is
 * visible for the current user. When the flag is off / loading / not visible,
 * this component renders nothing and the existing Home screen stands alone.
 *
 * Home    → existing /designer flow (unchanged)
 * Refresh → /room-refresh screen
 */
export const BottomTabBar = () => {
  const navigate = useNavigate();
  const { loading, visible } = useRoomRefreshFlag();

  if (loading || !visible) return null;

  // Determine active tab from the current path.
  const path = window.location.pathname;
  const isRefresh = path.startsWith("/room-refresh");

  return (
    <nav className="w-full bg-[#FFF7F1] border-t border-border safe-area-inset-bottom">
      <div className="flex">
        <button
          onClick={() => navigate("/designer")}
          className={`flex-1 flex flex-col items-center justify-center gap-0.5 py-2.5 text-[11px] font-medium transition-colors ${
            !isRefresh ? "text-primary" : "text-muted-foreground"
          }`}
        >
          <Home className="w-5 h-5" />
          Home
        </button>
        <button
          onClick={() => navigate("/room-refresh")}
          className={`flex-1 flex flex-col items-center justify-center gap-0.5 py-2.5 text-[11px] font-medium transition-colors ${
            isRefresh ? "text-primary" : "text-muted-foreground"
          }`}
        >
          <Sparkles className="w-5 h-5" />
          Refresh
        </button>
      </div>
    </nav>
  );
};
